//#region types
//#endregion
//#region components
import { Grid, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { PropsWithChildren } from "react";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const EditableTableTab: React.FC<PropsWithChildren> = (props) => {
  return (
    <TableCell className={cssExports.tabContainerCell}>
      <Grid item>
        <Table>
          <TableBody>
            <TableRow>{props.children}</TableRow>
          </TableBody>
        </Table>
      </Grid>
    </TableCell>
  );
};

export default EditableTableTab;
